import { CustomUoms } from 'records/CustomUom';
import { List, Map } from 'immutable';

import {
  CUSTOMUOM_ASYNC_ACTION_START,
  CUSTOMUOM_ASYNC_ACTION_ERROR,
  CUSTOMUOM_ASYNC_ACTION_SUCCESS,
  CUSTOMUOM_COMMON_ASYNC_ACTION_SUCCESS,
  CUSTOMUOM_ASYNC_CREATE_ACTION_SUCCESS,
  CUSTOMUOM_RESET_STATE,
} from 'actions/customUom';

const initialState = Map({
  loading: false,
  errorMessage: null,
  data: List(),
  common: List(),
});

const actionsMap = {
  [CUSTOMUOM_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [CUSTOMUOM_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [CUSTOMUOM_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const data = CustomUoms(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data,
    });
  },
  [CUSTOMUOM_COMMON_ASYNC_ACTION_SUCCESS]: (state, action) => {
    const data = CustomUoms(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      common: data,
    });
  },
  [CUSTOMUOM_ASYNC_CREATE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [CUSTOMUOM_RESET_STATE]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: List(),
      common: List(),
    });
  },
};

export default function customUom(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
